import { TableContainer, styled } from '@mui/material';

export const BudgetTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: '5px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.common.white,

  '& .MuiTableHead-root': {
    height: '78px',

    '& .MuiTableCell-head': {
      verticalAlign: 'bottom',
      borderBottom: `1px solid ${theme.palette.border.main}`,
    },

    '& .MuiTableCell-head:last-child': {
      paddingRight: '32px',
    },
  },

  '& .MuiTableBody-root': {
    '& .MuiTableRow-root': {
      borderColor: theme.palette.border.main,
    },

    '& .MuiTableRow-root:last-child, & .MuiTableRow-root:nth-last-child(2)': {
      border: 'none',
    },

    '& .MuiTableCell-root': {
      padding: '12px 16px',
      borderBottom: 'none',
    },

    '& .MuiTableCell-root:last-child': {
      paddingRight: '32px',
    },
  },

  // styles for nested collapsible table
  '& .MuiCollapse-root': {
    '& .MuiTableHead-root': {
      height: '32px',

      '& .MuiTableCell-head': {
        padding: '3px 16px',
        borderBottom: 'none',
        position: 'relative',

        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          height: '1px',
          backgroundColor: theme.palette.border.main,
        },
      },

      '& .MuiTableCell-head:first-child': {
        paddingLeft: '32px',

        '&::after': {
          left: '20px',
          width: 'calc(100% - 20px)',
        },
      },

      '& .MuiTableCell-head:last-child': {
        paddingRight: '32px',

        '&::after': {
          right: '20px',
          width: 'calc(100% - 20px)',
        },
      },

      '& .MuiTableCell-head:not(:first-child):not(:last-child)': {
        '&::after': {
          left: 0,
          width: '100%',
        },
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        borderBottom: 'none',
      },

      '& .MuiTableCell-root': {
        position: 'relative',

        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          height: '1px',
          backgroundColor: theme.palette.border.main,
        },

        '&:first-child': {
          paddingLeft: '32px',

          '&::after': {
            left: '20px',
            width: 'calc(100% - 20px)',
          },
        },

        '&:last-child': {
          paddingRight: '32px',

          '&::after': {
            right: '20px',
            width: 'calc(100% - 20px)',
          },
        },

        '&:not(:first-child):not(:last-child)': {
          '&::after': {
            left: 0,
            width: '100%',
          },
        },
      },
    },
  },
}));
